/**
 * Polyfills for iOS 14.1 / Safari 14 support
 * Import this file FIRST in _app.tsx before any other imports
 */

// Array methods not supported in iOS 14.1
import 'core-js/features/array/at';
import 'core-js/features/array/find-last';
import 'core-js/features/array/find-last-index';

// Object methods
import 'core-js/features/object/has-own';

// Promise methods
import 'core-js/features/promise/with-resolvers';

// Typed Array methods
import 'core-js/features/typed-array/at';
import 'core-js/features/typed-array/find-last';
import 'core-js/features/typed-array/find-last-index';

// String methods for older Safari versions
import 'core-js/features/string/replace-all';
